import { Box, List, ListIcon, ListItem } from "@chakra-ui/react";
import { Check, AltArrowForward } from "@airhelp/icons";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import type { SbEditableComponentProps } from "types/storyblok";
import type { UnstyledListWithIconProps } from "./UnstyledListWithIcon.d";

const icons = {
  Check,
  AltArrowForward,
};

export const UnstyledListWithIcon = ({
  items,
  itemsSpacing,
  sbEditable,
}: SbEditableComponentProps<UnstyledListWithIconProps>) => (
  <List spacing={itemsSpacing} {...sbEditable}>
    {items?.map(({ icon, content, iconColor, iconSize }) => {
      const isContentPresent = !isEmpty(content);

      return (
        <ListItem key={Math.random().toString(36)} display="flex">
          {icon && isContentPresent && <ListIcon boxSize={iconSize} as={icons[icon]} color={iconColor} />}

          <Box>
            {isContentPresent && (
              <RichtextAdapter content={content} customStyles={{ paragraph: { fontSize: "md", display: "inline" } }} />
            )}
          </Box>
        </ListItem>
      );
    })}
  </List>
);
